import React, { lazy } from "react";
import Axios from "axios";
import Toastr from "toastr";
import Swal from "sweetalert2";
import Env from "./env";
import ReactJson from "react-json-view";
import { renderToString } from "react-dom/server";

// import FingerprintJS from "@fingerprintjs/fingerprintjs";

const providerDisplayMerchantOrder = () => {
    return Env.providerDisplayMerchantOrder;
};

const providerAgentDisplayMerchantOrder = () => {
    return Env.providerAgentDisplayMerchantOrder;
};

const merchantDisplayProviderOrder = () => {
    return Env.merchantDisplayProviderOrder;
};

const merchantAgentDisplayProviderOrder = () => {
    return Env.merchantAgentDisplayProviderOrder;
};

const agentDisplayCreateButton = () => {
    return Env.agentDisplayCreateButton;
};

const merchantCanCancelWithdrawalOrder = () => {
    return Env.merchantCanCancelWithdrawalOrder;
};

const getWsLink = () => {
    return Env.wsProtocol + "://" + Env.wsDomain + ":" + Env.wsPort;
};

let setAxiosConfig = async (
    url,
    datas = {},
    method = "POST",
    isCashier = false,
    fakeReferer = false,
    fakeRefererHost = ""
) => {
    if (!isCashier) {
        datas.device = "WEB";

        // let uuid = getUUID(window.location.hostname);
        // datas.uuid = uuid;
        let uuid = await getFingerVisitorID();
        datas.uuid = uuid;

        // let localHash = this.state.loginInfo.hash;
        // if (localHash != null) {
        //     datas.hash = localHash;
        // }

        // let localAccount = this.state.loginInfo.account;
        // if (localAccount != null && !datas.hasOwnProperty("account")) {
        //     datas.account = localAccount;
        // }
        // if (this.state.loginInfo.class == "A") {
        //     datas.agType = this.state.loginInfo.agType;
        // }
        // if (this.state.loginInfo.class == "P") {
        //     let phoneNumber = localStorage.getItem("phoneNumber");
        //     if (phoneNumber) {
        //         datas.phoneNumber = phoneNumber;
        //         datas.device = "APP";
        //         datas.uuid = localStorage.getItem("appUuid");
        //     }
        // }
    }

    let setHeaders = {
        "Content-Type": "application/json",
        "cache-control": "no-cache",
    };
    if (fakeReferer) {
        setHeaders["Referrer-Policy"] = "no-referrer";
        if (fakeRefererHost != "") {
            setHeaders["referer"] = "https://" + fakeRefererHost + "/";
            setHeaders["host"] = fakeRefererHost;
        }
    }

    let settings = {
        crossDomain: true,
        url: url,
        method: method,
        headers: setHeaders,
        data: datas,
    };

    return settings;
};

let setAxiosConfigHeader = async (
    url,
    datas = {},
    setHeaders = {},
    method = "POST",
    isCashier = false,
    proxyInfo = null,
    fakeReferer = false,
    fakeRefererHost = ""
) => {
    if (!isCashier) {
        datas.device = "WEB";

        // let uuid = getUUID(window.location.hostname);
        // datas.uuid = uuid;
        let uuid = await getFingerVisitorID();
        datas.uuid = uuid;

        // let localHash = this.state.loginInfo.hash;
        // if (localHash != null) {
        //     datas.hash = localHash;
        // }

        // let localAccount = this.state.loginInfo.account;
        // if (localAccount != null && !datas.hasOwnProperty("account")) {
        //     datas.account = localAccount;
        // }
        // if (this.state.loginInfo.class == "A") {
        //     datas.agType = this.state.loginInfo.agType;
        // }
        // if (this.state.loginInfo.class == "P") {
        //     let phoneNumber = localStorage.getItem("phoneNumber");
        //     if (phoneNumber) {
        //         datas.phoneNumber = phoneNumber;
        //         datas.device = "APP";
        //         datas.uuid = localStorage.getItem("appUuid");
        //     }
        // }
    }

    setHeaders["Content-Type"] = "application/json";
    setHeaders["cache-control"] = "no-cache";

    if (fakeReferer) {
        setHeaders["Referrer-Policy"] = "no-referrer";
        if (fakeRefererHost != "") {
            setHeaders["referer"] = "https://" + fakeRefererHost + "/";
            setHeaders["host"] = fakeRefererHost;
        }
    }

    let settings = {
        crossDomain: true,
        url: url,
        method: method,
        headers: setHeaders,
        data: datas,
        validateStatus: function (status) {
            // return status >= 200 && status < 500;
            return true;
        },
    };
    if (proxyInfo != null) {
        settings.proxy = proxyInfo;
    }

    return settings;
};

let setAxiosConfigProtoHeader = async (
    url,
    datas = {},
    setHeaders = {},
    method = "POST",
    isCashier = false,
    proxyInfo = null,
    fakeReferer = false,
    fakeRefererHost = ""
) => {
    if (!isCashier) {
        datas.device = "WEB";

        // let uuid = getUUID(window.location.hostname);
        // datas.uuid = uuid;
        let uuid = await getFingerVisitorID();
        datas.uuid = uuid;

        // let localHash = this.state.loginInfo.hash;
        // if (localHash != null) {
        //     datas.hash = localHash;
        // }

        // let localAccount = this.state.loginInfo.account;
        // if (localAccount != null && !datas.hasOwnProperty("account")) {
        //     datas.account = localAccount;
        // }
        // if (this.state.loginInfo.class == "A") {
        //     datas.agType = this.state.loginInfo.agType;
        // }
        // if (this.state.loginInfo.class == "P") {
        //     let phoneNumber = localStorage.getItem("phoneNumber");
        //     if (phoneNumber) {
        //         datas.phoneNumber = phoneNumber;
        //         datas.device = "APP";
        //         datas.uuid = localStorage.getItem("appUuid");
        //     }
        // }
    }

    setHeaders["Content-Type"] = "application/protobuf";
    setHeaders["cache-control"] = "no-cache";

    if (fakeReferer) {
        setHeaders["Referrer-Policy"] = "no-referrer";
        if (fakeRefererHost != "") {
            setHeaders["referer"] = "https://" + fakeRefererHost + "/";
            setHeaders["host"] = fakeRefererHost;
        }
    }

    let settings = {
        crossDomain: true,
        url: url,
        method: method,
        headers: setHeaders,
        data: datas,
        validateStatus: function (status) {
            // return status >= 200 && status < 500;
            return true;
        },
    };
    if (proxyInfo != null) {
        settings.proxy = proxyInfo;
    }

    return settings;
};

let setAxiosConfigGet = async (url, method = "GET") => {
    let setHeaders = {
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Headers": "*",
        // "Access-Control-Allow-Methods": "*",
        "Content-Type": "application/json",
        "cache-control": "no-cache",
    };

    let settings = {
        crossdomain: true,
        url: url,
        method: method,
        headers: setHeaders,
    };

    return settings;
};

let setAxiosConfigGetHeader = async (
    url,
    setHeaders = {},
    proxyInfo = null,
    method = "GET"
) => {
    // setHeaders["Access-Control-Allow-Origin"] = "*";
    // setHeaders["Access-Control-Allow-Headers"] = "*";
    // setHeaders["Access-Control-Allow-Methods"] = "*";
    // setHeaders["Content-Type"] = "application/json";
    // setHeaders["cache-control"] = "no-cache";

    let settings = {
        crossdomain: true,
        url: url,
        method: method,
        headers: setHeaders,
        validateStatus: function (status) {
            // return status >= 200 && status < 500;
            return true;
        },
    };
    if (proxyInfo != null) {
        settings.proxy = proxyInfo;
    }

    return settings;
};

let setAjaxOptions = async (
    url,
    isAsync = true,
    datas = {},
    method = "POST",
    isCashier = false
) => {
    if (!isCashier) {
        datas.device = "WEB";

        // let uuid = getUUID(window.location.hostname);
        let uuid = await getFingerVisitorID();
        datas.uuid = uuid;

        let localHash = this.state.loginInfo.hash;
        if (localHash != null) {
            datas.hash = localHash;
        }

        let localAccount = this.state.loginInfo.account;
        if (localAccount != null && !datas.hasOwnProperty("account")) {
            datas.account = localAccount;
        }
    }

    let setHeaders = {
        "X-XSRF-TOKEN": $.cookie("XSRF-TOKEN"),
    };

    let options = {
        crossDomain: true,
        url: url,
        contentType: "application/x-www-form-urlencoded",
        cache: false,
        async: isAsync,
        type: method,
        headers: setHeaders,
        data: datas,
    };

    showLog(options);

    return options;
};

let toastrAlert = (
    type,
    msg,
    position = 2,
    progressBar = false,
    showDuration = "300",
    hideDuration = "1000",
    timeOut = "3000",
    extendedTimeOut = "1500"
) => {
    let pos = "";

    switch (position) {
        case 0:
            pos = "toast-top-left";
            break;
        case 1:
            pos = "toast-top-center";
            break;
        case 2:
            pos = "toast-top-right";
            break;
        case 3:
            pos = "toast-middle-left";
            break;
        case 4:
            pos = "toast-middle-center";
            break;
        case 5:
            pos = "toast-middle-right";
            break;
        case 6:
            pos = "toast-bottom-left";
            break;
        case 7:
            pos = "toast-bottom-center";
            break;
        case 8:
            pos = "toast-bottom-right";
            break;
        case 9:
            pos = "toast-top-full-width";
            break;
        case 10:
            pos = "toast-bottom-full-width";
            break;
    }

    Toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: progressBar,
        positionClass: pos,
        preventDuplicates: true,
        onclick: null,
        showDuration: showDuration,
        hideDuration: hideDuration,
        timeOut: timeOut,
        extendedTimeOut: extendedTimeOut,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
    };

    switch (type) {
        case "success":
            Toastr.success(msg);
            break;
        case "info":
            Toastr.info(msg);
            break;
        case "warning":
            Toastr.warning(msg);
            break;
        case "error":
            Toastr.error(msg);
            break;
    }
};

let toastrForClick = (
    type,
    msg,
    clickCallback,
    position = 2,
    progressBar = true,
    showDuration = "300",
    hideDuration = "1000",
    timeOut = "15000",
    extendedTimeOut = "10000"
) => {
    let pos = "";

    switch (position) {
        case 0:
            pos = "toast-top-left";
            break;
        case 1:
            pos = "toast-top-center";
            break;
        case 2:
            pos = "toast-top-right";
            break;
        case 3:
            pos = "toast-middle-left";
            break;
        case 4:
            pos = "toast-middle-center";
            break;
        case 5:
            pos = "toast-middle-right";
            break;
        case 6:
            pos = "toast-bottom-left";
            break;
        case 7:
            pos = "toast-bottom-center";
            break;
        case 8:
            pos = "toast-bottom-right";
            break;
        case 9:
            pos = "toast-top-full-width";
            break;
        case 10:
            pos = "toast-bottom-full-width";
            break;
    }

    Toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: progressBar,
        positionClass: pos,
        preventDuplicates: true,
        onclick: null,
        showDuration: showDuration,
        hideDuration: hideDuration,
        timeOut: timeOut,
        extendedTimeOut: extendedTimeOut,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        onclick: () => clickCallback(),
    };

    switch (type) {
        case "success":
            Toastr.success(msg);
            break;
        case "info":
            Toastr.info(msg);
            break;
        case "warning":
            Toastr.warning(msg);
            break;
        case "error":
            Toastr.error(msg);
            break;
    }
};

let bin2hex = (s) => {
    var i,
        l,
        o = "",
        n;

    s += "";

    for (i = 0, l = s.length; i < l; i++) {
        n = s.charCodeAt(i).toString(16);
        o += n.length < 2 ? "0" + n : n;
    }

    return o;
};

let getUUID = (domain) => {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    let txt = domain;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "tencent";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    let b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    let bin = atob(b64);
    let crc = bin2hex(bin.slice(-16, -12));
    return crc;
};

let getFingerVisitorID = async () => {
    const fpPromise = FingerprintJS.load();

    const fp = await fpPromise;
    const result = await fp.get();

    // This is the visitor identifier:
    const visitorId = result.visitorId;
    return visitorId;
};

let checkAuthStatus = async () => {
    let checkStatus = 0;
    let checkData = {};
    let axConfig = await setAxiosConfig("/status/check");
    try {
        let res = await Axios(axConfig);
        showLog(res);
        checkStatus = res.data.code;
        if (res.data.code != 0) {
            if (res.data.message && res.data.message.includes("CSRF")) {
                window.location.href = "/";
                return;
            }
        } else {
            let loginInfo = {
                account: res.data.data.account,
                hash: res.data.data.hash,
                ip: res.data.data.ip,
                nickname: res.data.data.nickname,
                class: res.data.data.class,
                className: res.data.data.className,
                spcCode: res.data.data.spcCode ? res.data.data.spcCode : "",
                spcGuid: res.data.data.spcGuid ? res.data.data.spcGuid : "",
            };
            if (res.data.data.class == "S") {
                loginInfo.auth_code = res.data.data.auth_code;
            }
            if (res.data.data.class == "A") {
                loginInfo.agType = res.data.data.agType;
                loginInfo.amType = res.data.data.amType;
            }
            if (res.data.data.class == "P") {
                loginInfo.provider = res.data.data.provider;
            }
            checkData = loginInfo;
        }
    } catch (err) {
        showError(err);
    }

    // let aaConfig = setAjaxOptions("/status/check", false);
    // $.ajax(aaConfig)
    //     .done(function (res) {
    //         showLog(res);
    //     })
    //     .fail(function (jqXHR, textStatus, errorThrown) {
    //         showLog(jqXHR);
    //         showLog(textStatus);
    //         showLog(errorThrown);
    //     })
    //     .always(function () {
    //         showLog("always");
    //     });

    let response = {
        status: checkStatus,
        data: checkData,
    };

    return response;
};

let clearAuthStatus = async () => {
    let checkStatus = 1;
    let axConfig = await setAxiosConfig("/status/clear");
    try {
        let res = await Axios(axConfig);
        localStorage.clear();
        if (
            res.data.code == null &&
            res.data.message &&
            res.data.message.includes("CSRF")
        ) {
            window.location.href = "/";
        }
        if (res.data.status) {
            window.location.href = "/";
        }
        showLog(res);
    } catch (err) {
        showError(err);
        checkStatus = 0;
    }
    return checkStatus;
};

let getMenu = async () => {
    let routes = new Array();

    let axConfig = await setAxiosConfig("/user/menu");

    try {
        let res = await Axios(axConfig);

        routes = res.data.data.map((route, index) => {
            let temp = route;
            if (temp.type == "C") {
                temp.component = "";
                let childs = temp.items.map((child, idx) => {
                    child.component = lazy(() =>
                        import("./components/pages/" + child.name)
                    );
                    return child;
                });
                temp.items = childs;
            } else if (temp.type == "P") {
                temp.component = lazy(() =>
                    import("./components/pages/" + temp.name)
                );
            }

            return temp;
        });
    } catch (err) {
        showError(err);
    }

    // showLog(routes);
    return routes;
};

let getHomeMenu = (routes = null) => {
    let listItems = new Array();

    if (routes.length != 0) {
        $.each(routes, (index, route) => {
            if (route.type == "C") {
                if (route.items.length != 0) {
                    let newRoutes = route.items;
                    let childLists = getHomeMenu(newRoutes);
                    if (childLists.length != 0) {
                        listItems = $.merge(listItems, childLists);
                    }
                }
            } else if (route.type == "P") {
                if (route.path != "") {
                    listItems.push({
                        path: route.path,
                        exact: route.exact,
                        component: route.component,
                    });
                }
            }
        });
    }

    return listItems;
};

let swalAlert = (title, text, icon = "info", timer = 5000) => {
    Swal.fire({
        title: title,
        html: text,
        icon: icon,
        timer: timer == 0 ? 180000 : timer,
    });
};

let swalAlertQrCode = (title, imgText, icon = "info") => {
    Swal.fire({
        title: title,
        html: imgText,
        icon: icon,
    });
};

let swalAlertJson = (title, jsonData, icon = "info") => {
    let text =
        '<div class="text-xs" style="text-align:left;word-break:break-all">' +
        renderToString(
            <ReactJson
                name={"collect"}
                collapseStringsAfterLength={256}
                collapsed={false}
                displayDataTypes={false}
                displayObjectSize={false}
                enableClipboard={true}
                iconStyle={"triangle"}
                indentWidth={2}
                onAdd={false}
                onDelete={false}
                onEdit={false}
                onSelect={false}
                quotesOnKeys={true}
                shouldCollapse={false}
                sortKeys={false}
                theme={"rjv-default"}
                src={jsonData}
            />
        ) +
        "</div>";
    Swal.fire(title, text, icon);
};

let swalAlertFunction = (
    title,
    text,
    icon = "info",
    buttonCallback,
    timer = 5000
) => {
    Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: false,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "OK",
        timer: timer == 0 ? 180000 : timer,
    }).then((result) => {
        if (result.isConfirmed) {
            buttonCallback();
        } else {
            buttonCallback();
        }
    });
};

let swalConfirm = (title, text, icon, confirmCallback, cancelCallback) => {
    Swal.fire({
        title: title,
        html: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else {
            cancelCallback();
        }
    });
};

let swalConfirmThree = (
    title,
    text,
    icon,
    confirmCallback,
    cancelCallback,
    denyCallback
) => {
    Swal.fire({
        title: title,
        html: text,
        icon: icon,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        denyButtonColor: "#2F85D6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        denyButtonText: "Yes & Reload",
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (result.isDenied) {
            denyCallback();
        } else {
            cancelCallback();
        }
    });
};

let swalImage = (title, text, imageUrl, alt = "") => {
    Swal.fire({
        title: title,
        text: text,
        imageUrl: imageUrl,
        imageWidth: 300,
        imageHeight: 300,
        imageAlt: alt,
    });
};

let swalConfirmSimpleInput = (
    title,
    text,
    icon,
    confirmCallback,
    cancelCallback,
    defaultValue = ""
) => {
    Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        input: "text",
        inputValue: defaultValue,
        inputAttributes: {
            autocapitalize: "off",
        },
        preConfirm: (userInput) => {
            return userInput;
        },
    }).then((result) => {
        if (result.isConfirmed) {
            // if (result.value != "") {
            //     confirmCallback(result.value);
            // } else {
            //     cancelCallback();
            // }
            confirmCallback(result.value);
        } else {
            cancelCallback();
        }
    });
};

let swalConfirmTwinsInput = (
    title,
    confirmCallback,
    cancelCallback,
    defaultValue1 = "",
    defaultValue2 = "",
    defaultValue1P = "",
    defaultValue2P = ""
) => {
    Swal.fire({
        title: title,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        html:
            '<input id="swal-input1" class="swal2-input" placeholder="' +
            defaultValue1P +
            '"value="' +
            defaultValue1 +
            '">' +
            '<input id="swal-input2" class="swal2-input" placeholder="' +
            defaultValue2P +
            '" value="' +
            defaultValue2 +
            '">',
        focusConfirm: false,
        preConfirm: () => {
            return {
                txt1: document.getElementById("swal-input1").value,
                txt2: document.getElementById("swal-input2").value,
            };
        },
    }).then((result) => {
        if (result.isConfirmed) {
            // if (result.value.txt1 != "" && result.value.txt2 != "") {
            //     confirmCallback(result.value);
            // } else {
            //     cancelCallback();
            // }
            confirmCallback(result.value);
        } else {
            cancelCallback();
        }
    });
};

let swalConfirmThreeInput = (
    title,
    confirmCallback,
    cancelCallback,
    defaultValue1 = "",
    defaultValue2 = "",
    defaultValue3 = "",
    defaultValue1P = "",
    defaultValue2P = "",
    defaultValue3P = ""
) => {
    Swal.fire({
        title: title,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        html:
            '<input id="swal-input1" class="swal2-input" placeholder="' +
            defaultValue1P +
            '"value="' +
            defaultValue1 +
            '">' +
            '<input id="swal-input2" class="swal2-input" placeholder="' +
            defaultValue2P +
            '" value="' +
            defaultValue2 +
            '">' +
            '<input id="swal-input3" class="swal2-input" placeholder="' +
            defaultValue3P +
            '" value="' +
            defaultValue3 +
            '">',
        focusConfirm: false,
        preConfirm: () => {
            return {
                txt1: document.getElementById("swal-input1").value,
                txt2: document.getElementById("swal-input2").value,
                txt3: document.getElementById("swal-input3").value,
            };
        },
    }).then((result) => {
        if (result.isConfirmed) {
            // if (result.value.txt1 != "" && result.value.txt2 != "") {
            //     confirmCallback(result.value);
            // } else {
            //     cancelCallback();
            // }
            confirmCallback(result.value);
        } else {
            cancelCallback();
        }
    });
};

let swalConfirmFourInput = (
    title,
    confirmCallback,
    cancelCallback,
    defaultValue1 = "",
    defaultValue2 = "",
    defaultValue3 = "",
    defaultValue4 = "",
    defaultValue1P = "",
    defaultValue2P = "",
    defaultValue3P = "",
    defaultValue4P = ""
) => {
    Swal.fire({
        title: title,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        html:
            '<input id="swal-input1" class="swal2-input" placeholder="' +
            defaultValue1P +
            '"value="' +
            defaultValue1 +
            '">' +
            '<input id="swal-input2" class="swal2-input" placeholder="' +
            defaultValue2P +
            '" value="' +
            defaultValue2 +
            '">' +
            '<input id="swal-input3" class="swal2-input" placeholder="' +
            defaultValue3P +
            '" value="' +
            defaultValue3 +
            '">' +
            '<input id="swal-input4" class="swal2-input" placeholder="' +
            defaultValue4P +
            '" value="' +
            defaultValue4 +
            '">',
        focusConfirm: false,
        preConfirm: () => {
            return {
                txt1: document.getElementById("swal-input1").value,
                txt2: document.getElementById("swal-input2").value,
                txt3: document.getElementById("swal-input3").value,
                txt4: document.getElementById("swal-input4").value,
            };
        },
    }).then((result) => {
        if (result.isConfirmed) {
            // if (result.value.txt1 != "" && result.value.txt2 != "") {
            //     confirmCallback(result.value);
            // } else {
            //     cancelCallback();
            // }
            confirmCallback(result.value);
        } else {
            cancelCallback();
        }
    });
};

let swalConfirmTwinsInputWithLabel = (
    title,
    confirmCallback,
    cancelCallback,
    defaultValue1 = "",
    defaultValue2 = "",
    defaultValue1P = "",
    defaultValue2P = "",
    label1 = "",
    label2 = ""
) => {
    Swal.fire({
        title: title,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        html:
            "<div><label>" +
            label1 +
            "</label>" +
            '<input id="swal-input1" class="swal2-input" placeholder="' +
            defaultValue1P +
            '"value="' +
            defaultValue1 +
            '"></div>' +
            "<div><label>" +
            label2 +
            "</label>" +
            '<input id="swal-input2" class="swal2-input" placeholder="' +
            defaultValue2P +
            '" value="' +
            defaultValue2 +
            '"></div>',
        focusConfirm: false,
        preConfirm: () => {
            return {
                txt1: document.getElementById("swal-input1").value,
                txt2: document.getElementById("swal-input2").value,
            };
        },
    }).then((result) => {
        if (result.isConfirmed) {
            // if (result.value.txt1 != "" && result.value.txt2 != "") {
            //     confirmCallback(result.value);
            // } else {
            //     cancelCallback();
            // }
            confirmCallback(result.value);
        } else {
            cancelCallback();
        }
    });
};

let showLog = (infos) => {
    if (Env.debug) {
        console.log(infos);
    }
};

let showError = (infos) => {
    if (Env.debug) {
        console.log(infos);
    }
};

let getQueryLimitOption = (def = 0) => {
    let options = [
        { value: "0", text: "NotLimit", default: def == 0 ? true : false },
        { value: "50", text: "50", default: def == 50 ? true : false },
        { value: "100", text: "100", default: def == 100 ? true : false },
        { value: "500", text: "500", default: def == 500 ? true : false },
        // { value: "1000", text: "1000", default: def == 1000 ? true : false },
        // { value: "3000", text: "3000", default: def == 3000 ? true : false },
        // { value: "5000", text: "5000", default: def == 5000 ? true : false },
        // { value: "10000", text: "10000", default: def == 10000 ? true : false },
        // { value: "20000", text: "20000", default: def == 20000 ? true : false },
    ];

    return options;
};

let getQueryLimitOptionEx = (def = 0) => {
    let options = [
        { value: "50", text: "50", default: def == 50 ? true : false },
        { value: "100", text: "100", default: def == 100 ? true : false },
        { value: "500", text: "500", default: def == 500 ? true : false },
        // { value: "1000", text: "1000", default: def == 1000 ? true : false },
        // { value: "3000", text: "3000", default: def == 3000 ? true : false },
        // { value: "5000", text: "5000", default: def == 5000 ? true : false },
        // { value: "10000", text: "10000", default: def == 10000 ? true : false },
        // { value: "20000", text: "20000", default: def == 20000 ? true : false },
    ];

    return options;
};

let toBase64 = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

let fileToBase64Code = async (elementId) => {
    let file = document.querySelector("#" + elementId).files[0];
    let fileSize = file.size;
    let size = fileSize / 1024;
    if (size > 500) {
        swalAlert("warning", "Image size must not exceed 500KB", "warning");
        document.querySelector("#" + elementId).value = "";
        return "";
    }
    if (file) {
        let res = await toBase64(file);
        showLog(res);
        return res;
    } else {
        return "";
    }
};

const disableReactDevTools = () => {
    if (!Env.debug) {
        const noop = () => undefined;
        /* eslint-disable no-underscore-dangle */
        let DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;

        if (typeof DEV_TOOLS === "object") {
            for (const [key, value] of Object.entries(DEV_TOOLS)) {
                DEV_TOOLS[key] = typeof value === "function" ? noop : null;
            }
            $.each(Object.entries(DEV_TOOLS), function (key, value) {
                DEV_TOOLS[key] = typeof value === "function" ? noop : null;
            });
        }
    }
};

let synth = window.speechSynthesis;
let voices = [];
let voicesList = () => {
    voices = synth.getVoices().sort(function (a, b) {
        const aname = a.name.toUpperCase(),
            bname = b.name.toUpperCase();
        if (aname < bname) return -1;
        else if (aname == bname) return 0;
        else return +1;
    });
};
let speakVoice = (text) => {
    voicesList();
    if (synth.speaking) {
        showError("speechSynthesis.speaking");
        return;
    }
    let utterThis = new SpeechSynthesisUtterance(text);
    utterThis.onend = function (event) {
        showLog("SpeechSynthesisUtterance.onend");
    };
    utterThis.onerror = function (event) {
        showError("SpeechSynthesisUtterance.onerror");
        showError(event);
    };
    for (let i = 0; i < voices.length; i++) {
        if (voices[i].name === "Mei-Jia") {
            utterThis.voice = voices[i];
            break;
        }
    }
    synth.speak(utterThis);
};

let isJson = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return false;
    }
};

let iconImg = () => {
    return "/images/favicons/" + Env.icon + "/apple-touch-icon.png";
};

let sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

let getQueryStringByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export default {
    providerDisplayMerchantOrder: providerDisplayMerchantOrder,
    providerAgentDisplayMerchantOrder: providerAgentDisplayMerchantOrder,
    merchantDisplayProviderOrder: merchantDisplayProviderOrder,
    merchantAgentDisplayProviderOrder: merchantAgentDisplayProviderOrder,
    agentDisplayCreateButton: agentDisplayCreateButton,
    merchantCanCancelWithdrawalOrder: merchantCanCancelWithdrawalOrder,
    getWsLink: getWsLink,
    setAxiosConfig: setAxiosConfig,
    setAxiosConfigHeader: setAxiosConfigHeader,
    setAxiosConfigProtoHeader: setAxiosConfigProtoHeader,
    setAxiosConfigGet: setAxiosConfigGet,
    setAxiosConfigGetHeader: setAxiosConfigGetHeader,
    setAjaxOptions: setAjaxOptions,
    toastrAlert: toastrAlert,
    toastrForClick: toastrForClick,
    bin2hex: bin2hex,
    getUUID: getUUID,
    getFingerVisitorID: getFingerVisitorID,
    getMenu: getMenu,
    getHomeMenu: getHomeMenu,
    checkAuthStatus: checkAuthStatus,
    clearAuthStatus: clearAuthStatus,
    swalAlert: swalAlert,
    swalAlertQrCode: swalAlertQrCode,
    swalAlertJson: swalAlertJson,
    swalAlertFunction: swalAlertFunction,
    swalConfirm: swalConfirm,
    swalConfirmThree: swalConfirmThree,
    swalConfirmSimpleInput: swalConfirmSimpleInput,
    swalConfirmTwinsInput: swalConfirmTwinsInput,
    swalConfirmThreeInput: swalConfirmThreeInput,
    swalConfirmFourInput: swalConfirmFourInput,
    swalConfirmTwinsInputWithLabel: swalConfirmTwinsInputWithLabel,
    swalImage: swalImage,
    showLog: showLog,
    showError: showError,
    getQueryLimitOption: getQueryLimitOption,
    getQueryLimitOptionEx: getQueryLimitOptionEx,
    fileToBase64Code: fileToBase64Code,
    disableReactDevTools: disableReactDevTools,
    speakVoice: speakVoice,
    isJson: isJson,
    iconImg: iconImg,
    sleep: sleep,
    getQueryStringByName: getQueryStringByName,
};
